import { RouteType } from "types/RouteType";
// import SettingsIcon from '@mui/icons-material/Settings';

const settingsRoutes: RouteType[] = [
  {
    name: "Settings",
    path: "/settings/:page",
    layout: "/app",
    defaultParams: {
      page: "user", // Default tab to show
    },
    viewportCard: {
      header: {
        title: "Settings",
        // icon: SettingsIcon, // Assuming icon can be placed here
        // If separate header component is needed:
        component: () => import("./Settings.Header"),
      },
      body: {
        component: () => import("./Settings.Body"),
        grayBackground: true, // Add if needed
      },
    },
    group: 'Settings',
  requiresAuth: true,
    requiresPermission: false,
    // beforeExit: async ({ rootStore }) => {
    //   rootStore?.routerStore?.clearAllRouterParams();
    // },
    // Assuming these properties apply to the new format.  If not remove them.
    // mini: 'AS', //  Not sure where 'mini' fits in the new format, perhaps in viewportCard.header?
    // Not sure where this fits in new format
    // hidden: true, // Not sure where this fits in new format
  },
];

export default settingsRoutes;
